import { CALL_API } from 'redux-api-middleware'
import Messages from '../constants/messages'
import { SET_APP_CONTEXT_RECEIVE } from './appContext';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

export const USER_PATCH_REQUEST = 'registration/USER_PATCH_REQUEST'
export const USER_PATCH_RECEIVE = 'registration/USER_PATCH_RECEIVE'
export const USER_PATCH_FAILURE = 'registration/USER_PATCH_FAILURE'
export const REGISTRATION_USER_REQUEST = 'registration/REGISTRATION_USER_REQUEST'
export const REGISTRATION_USER_RECEIVE = 'registration/REGISTRATION_USER_RECEIVE'
export const REGISTRATION_USER_FAILURE = 'registration/REGISTRATION_USER_FAILURE'

const initialState = {
  hasReceivedUserInfo: false, 
  isRegistering: false,
  expirationMessage: '',
  resetPassword: false,
  completedMessage: '',
  initialValues: {},
  userId: ''
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      let expirationMessage = ''
      let resetPassword = false
      let pathname = action.payload.pathname
      let userId

      if (pathname.includes('/user-registration-expired')) {
        expirationMessage = Messages['pageMessages']['REGISTRATION_EXPIRATION_MSG']
      } else if (pathname.includes('/reset-password-expired')) {
        resetPassword = true
        expirationMessage = Messages['pageMessages']['RESET_PASSWORD_EXPIRATION_MSG']
      } else if (pathname.includes('/registration/')) {
        userId = atob(pathname.match(/registration\/(.*)/)[1])
      } else if (pathname.includes('/reset-password/')) {
        resetPassword = true
        userId = atob(pathname.match(/reset-password\/(.*)/)[1])
      }
      return {
        ...state,
        expirationMessage,
        resetPassword,
        userId
      }
    case USER_PATCH_REQUEST:
      return {
        ...state,
        isRegistering: true
      }
    case USER_PATCH_RECEIVE:
      return {
        ...state,
        isRegistering: false,
        completedMessage: state.resetPassword ?
          Messages['pageMessages']['PASSWORD_CHANGED_MSG'] : Messages['pageMessages']['REGISTRATION_COMPLETE_MSG']
      }
    case USER_PATCH_FAILURE:
      return {
        ...state,
        isRegistering: false
      }
    case SET_APP_CONTEXT_RECEIVE:
      let app = action.meta.appInfo
      return {
        ...state,
        initialValues: {
          ...state.initialValues,
          appClientId: app.id,
          appName: app.name
        }
      }
    case REGISTRATION_USER_RECEIVE:
      let email = action.payload.data.item.email
      let partner = action.payload.data.item.partners ? action.payload.data.item.partners.map(partner => partner.name).join() : ''
      const firstName = action.payload.data.item.firstName
      const lastName = action.payload.data.item.lastName
      return {
        ...state,
        hasReceivedUserInfo: true,
        initialValues: {
          ...state.initialValues,
          email,
          partner,
          firstName,
          lastName
        }
      }
    default:
      return state
  }
}

export function patchUser(userId, data) {
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/users/${userId}` :
          `/api/v1/authz/users/${userId}`,
        method: 'PUT',
        body: JSON.stringify(data),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [USER_PATCH_REQUEST, USER_PATCH_RECEIVE, USER_PATCH_FAILURE]
      }
    })
  }
}

export function fetchRegistrationUser(userId) {
  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/users/${userId}` :
        `/api/v1/authz/users/${userId}`,
      method: 'GET',
      credentials: 'include',
      types: [REGISTRATION_USER_REQUEST, REGISTRATION_USER_RECEIVE, REGISTRATION_USER_FAILURE]
    }
  }
}

function isLocal() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

export default reducer
